var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{class:['bcq-macos-dock-open-app-indicator-container'],attrs:{"y-align":"middle","x-align":"center"}},[_c('div',{class:['rounded-full', 'bg-white', 'bcq-macos-dock-open-app-indicator', 'opacity-50', _vm.open ? null : 'invisible']})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322adc20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/macos-dock-app-marker/macos-dock-app-marker.vue
// module id = null
// module chunks = 